<!--
    描述：评价管理模块入口页面
    时间：2020-05-17
    Created by 王帅
-->
<template>
	<transition name="fade"
				mode="out-in">
		<router-view></router-view>
	</transition>
</template>

<script>
export default {
	name: 'Evaluate-management'
}
</script>